import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "my-3 d-flex justify-content-start gap-3 align-items-center form-check checkbox-checked" }
const _hoisted_4 = {
  class: "w-100 custom-scrollbar b-dash",
  style: {"height":"50dvh"}
}
const _hoisted_5 = {
  class: "nav-link",
  style: {"user-select":"none"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-dark" }

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Condiment } from '@/store/management/productsStore';
import { condimentsListMock } from '@/store/management/staticCondimentStore';
import draggable from "vuedraggable";

export default /*@__PURE__*/_defineComponent({
  __name: 'productCondiments',
  setup(__props) {

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const condimentData = productGroup.condiments
        compState.condimentList = condimentData.condimentList
        compState.required = condimentData.required
    }
})

const compState = reactive({
    required: false,
    condimentList: [] as Condiment[],
    condimentsListMock: condimentsListMock,
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const condimentData = productGroup.condiments
        compState.condimentList = condimentData.condimentList
        compState.required = condimentData.required
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        condiments: {
            condimentList: newVal.condimentList,
            required: newVal.required
        }
    })

}, { deep: true });

const onReOrder = () => {
    compState.condimentsListMock.sort((a, b) => {
        const aInGroup = isInCondimentGroup(a);
        const bInGroup = isInCondimentGroup(b);

        if (aInGroup && !bInGroup) {
            return -1;
        } else if (!aInGroup && bInGroup) {
            return 1;
        } else {
            return 0;
        }
    });
}

const onCondimentGroupClick = (condimentGroup: Condiment) => {
    if (compState.condimentList.includes(condimentGroup)) {
        compState.condimentList = compState.condimentList.filter(group => group !== condimentGroup);
    } else {
        compState.condimentList.push(condimentGroup);
    }
}

const isInCondimentGroup = (condimentGroup: Condiment) => {
    return compState.condimentList.includes(condimentGroup);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          id: "required-Condiment",
          type: "checkbox",
          value: "",
          style: {"margin":"0"},
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.required) = $event))
        }, null, 512), [
          [_vModelCheckbox, compState.required]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          class: "form-check-label",
          for: "required-Condiment",
          style: {"margin":"0"}
        }, "Condiments required", -1)),
        _createElementVNode("button", {
          class: "btn btn-outline-primary emailbox",
          type: "button",
          onClick: onReOrder,
          style: {"margin":"0"}
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa fa-sort" }, null, -1),
          _createTextVNode(" Reorder")
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(draggable), {
            modelValue: compState.condimentsListMock,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.condimentsListMock) = $event)),
            "item-key": "id",
            handle: ".handle",
            class: "box-list-container"
          }, {
            item: _withCtx(({ element: item }) => [
              _createVNode(_TransitionGroup, {
                name: "list",
                tag: "div"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-content-center align-items-center gap-2 handle",
                    onClick: ($event: any) => (onCondimentGroupClick(item)),
                    style: _normalizeStyle([{ boxShadow: isInCondimentGroup(item) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }, {"grid-column":"span 1 / span 1","height":"96px"}])
                  }, [
                    (item?.appearance?.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.appearance.image,
                          alt: "department image",
                          class: "object-fit-cover w-25 ratio1-1 border-0"
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(item.name), 1)
                  ], 12, _hoisted_6)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})